const baseOptions = {
  dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,
  sampleRate: 1,
  enabled: process.env.NEXT_PUBLIC_STAGE !== 'LOC',
  environment: process.env.NEXT_PUBLIC_STAGE,
  normalizeDepth: 6,
};

export default baseOptions;
